import React, { useState, useEffect } from "react";
import axios from "axios";
import "semantic-ui-css/semantic.min.css";
import { useAuth } from "../../../hook/userAuth";
import { Navigate, Link, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { BASE_API } from "../../../ruta-server/BaseApi";
import { Loader } from "semantic-ui-react";
import { TableListaACursos } from "../../../components/Users/TableTeachers/TableListaACursos/TableListaACursos";

function CalificarAlumnosCurso() {
  const { auth } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const datosCurso = location.state?.datosCurso;

  useEffect(() => {
    if (!datosCurso) {
      navigate("/mis-grupos");
    }
  }, [datosCurso, navigate]);

  if (!auth?.me?.es_docente) {
    return <Navigate to={"/"} />;
  }
  return datosCurso ? (
    <LogicaCalificarAlumnosCurso datosCurso={datosCurso} />
  ) : null;
}

function LogicaCalificarAlumnosCurso({ datosCurso }) {
  const { nombre_materia, clave_materia, semestre, numero_unidades } =
    datosCurso.materia_data;
  const { numero_grupo } = datosCurso.grupo_data;
  const { auth } = useAuth();
  const [refetch, setRefetch] = useState(false);
  const [alumnosCalificaciones, setAlumnosCalificaciones] = useState(null);
  const [loading, setLoading] = useState(true);

  async function getAlumnosCali() {
    try {
      setLoading(true);
      const response = await axios.get(
        `${BASE_API}/api/calificacion_curso/?curso=${datosCurso.id}`,
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );

      let result = response.data; // Cambiar 'const' a 'let' para permitir la reasignación

      if (datosCurso.materia_data.es_de_titulacion) {
        // Filtrar los resultados
        result = result.filter(
          (cursoCali) => cursoCali.docente_asesor === auth.me.id
        );
      }

      // Ordenar por apellido_paterno y apellido_materno
      result.sort((a, b) => {
        if (a.alumno_data.apellido_paterno < b.alumno_data.apellido_paterno) {
          return -1;
        }
        if (a.alumno_data.apellido_paterno > b.alumno_data.apellido_paterno) {
          return 1;
        }
        if (a.alumno_data.apellido_materno < b.alumno_data.apellido_materno) {
          return -1;
        }
        if (a.alumno_data.apellido_materno > b.alumno_data.apellido_materno) {
          return 1;
        }
        return 0;
      });

      setAlumnosCalificaciones(result);
      setLoading(false);
      return result;
    } catch (error) {
      setLoading(false);
      console.log(error);
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  useEffect(() => {
    getAlumnosCali();
    // eslint-disable-next-line
  }, [refetch]);

  const onRefetch = () => {
    setRefetch((prev) => !prev);
  };

  const formatPeriodo = (fecha) => {
    const opciones = { month: "long", year: "numeric" };
    const fechaFormateada = new Date(fecha).toLocaleDateString(
      "es-ES",
      opciones
    );
    return fechaFormateada;
  };

  return (
    <div>
      <h1 className="encabezado">Calificaciones</h1>
      <h1 className="encabezado">
        CURSO: <span className="nombreM">{nombre_materia} </span>{" "}
        <span> {clave_materia} </span>
      </h1>

      <h1 className="encabezado">
        GRUPO: {numero_grupo} <span> SEMESTRE: {semestre} </span> TURNO: M
        <span>
          {" "}
          PERIODO: {formatPeriodo(datosCurso.periodo_data.fecha_inicio)} -{" "}
          {formatPeriodo(datosCurso.periodo_data.fecha_fin)}
        </span>
      </h1>

      <h1 className="tituloin2"> </h1>

      <h6 className="sub">
        <Link to="/mis-grupos">Mis Grupos </Link>/ Grupo {numero_grupo}
      </h6>
      {loading ? (
        <Loader active inline="centered">
          Cargando....
        </Loader>
      ) : (
        <TableListaACursos
          datosCurso={datosCurso}
          alumnosCali={alumnosCalificaciones}
          numero_unidades={numero_unidades}
          onRefetch={onRefetch}
        />
      )}
    </div>
  );
}

export default CalificarAlumnosCurso;
